import { render, staticRenderFns } from "./PGrid.vue?vue&type=template&id=2b87cb74&scoped=true"
import script from "./PGrid.vue?vue&type=script&lang=js"
export * from "./PGrid.vue?vue&type=script&lang=js"
import style0 from "./PGrid.vue?vue&type=style&index=0&id=2b87cb74&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b87cb74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b87cb74')) {
      api.createRecord('2b87cb74', component.options)
    } else {
      api.reload('2b87cb74', component.options)
    }
    module.hot.accept("./PGrid.vue?vue&type=template&id=2b87cb74&scoped=true", function () {
      api.rerender('2b87cb74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/canvas/components/editor/PGrid.vue"
export default component.exports